/* ===========================================================================
   HAIKUTOKYO — cart line removal.

   The delete button in snippets/cart-item.liquid renders on every line item,
   but its only click handler lived inside the shipping-protection block in
   snippets/cart-drawer.liquid:

     {% if settings.enable_shipping_protection
           and settings.shipping_protection_product != blank %}
       ... <script> ... remove handler ... </script> ...
     {% endif %}

   That block resolves to false on this store — the configured protection
   product ('shipping-protection') does not exist here — so the script never
   reached the page and the button was inert. Nothing about removing a line
   item depends on shipping protection, so the handler belongs here, where it
   always loads, for both the drawer and the cart page.

   Removal goes through theme.cart.changeItem, the theme's own cart API, so
   the drawer, the header count and the totals all refresh the way they do
   for the quantity steppers.
   =========================================================================== */
(function () {
  'use strict';

  var BTN = '.cart-remove-btn';

  function rebuild(cart) {
    document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart: cart } }));
  }

  function changeItem(key, qty) {
    /* theme.cart is defined in theme.js; fall back to the endpoint directly so
       a removal still works if the cart object has not initialised yet. */
    if (window.theme && theme.cart && typeof theme.cart.changeItem === 'function') {
      return theme.cart.changeItem(key, qty).then(function (body) {
        try { return JSON.parse(body); } catch (e) { return null; }
      });
    }

    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  /* If a shipping-protection product is ever configured, the drawer sets this
     global. Left undefined, the clean-up below is simply skipped. */
  function protectionId() {
    var id = window.HK_PROTECTION_VARIANT_ID;
    return (id === undefined || id === null || id === '') ? null : String(id);
  }

  /* Protection should not be the only thing left in the cart. */
  function dropOrphanedProtection(cart) {
    var pid = protectionId();
    if (!pid || !cart || !cart.items) return Promise.resolve(cart);

    var others = cart.items.filter(function (i) { return String(i.id) !== pid; });
    if (others.length) return Promise.resolve(cart);

    var orphan = cart.items.find(function (i) { return String(i.id) === pid; });
    if (!orphan) return Promise.resolve(cart);

    return changeItem(orphan.key, 0);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest(BTN) : null;
    if (!btn) return;

    e.preventDefault();

    var key = btn.dataset.key;
    if (!key || btn.disabled) return;

    btn.disabled = true;

    changeItem(key, 0)
      .then(dropOrphanedProtection)
      .then(function (cart) { rebuild(cart); })
      .catch(function (err) {
        console.error('[HAIKUTOKYO] could not remove cart line:', err);
      })
      .then(function () { btn.disabled = false; });
  });
})();
